/**
 * Back-office roles (from the QL SSO token's `user.roles`).
 *
 * Each list MIRRORS a guard in QLM-Backend — the backend decides, this app only hides what the
 * user could not use anyway. If a list here drifts, the backend still answers 403.
 *
 * - CONTENT_ROLES: `@Roles(CONTENT_ADMIN, ADMINISTRATOR)` on `api/events-bo`, articles, uploads…
 * - TICKETING_*: `src/ticketing/common/request.util.ts` (QL Tickets, `api/ticketing-bo/*`).
 *
 * `ticketing_admin` / `ticketing_finance` are ticketing-only staff: they may sign in to the back
 * office, but they see only the Ticketing section (useAuth / AppContent / useNavigation).
 */
export const CONTENT_ROLES = ['administrator', 'content_admin']

/** May read every ticketing screen. */
export const TICKETING_READ_ROLES = [
  'administrator',
  'content_admin',
  'ticketing_admin',
  'ticketing_finance',
]

/** May change merchants, events, inventory and settings. */
export const TICKETING_WRITE_ROLES = ['administrator', 'content_admin', 'ticketing_admin']

/** May look up, save, remove and refresh a merchant's MyFatoorah supplier code (finance onboards suppliers). */
export const TICKETING_SUPPLIER_ROLES = [...TICKETING_WRITE_ROLES, 'ticketing_finance']

/** Any of these lets a user into the back office at all. */
export const BACKOFFICE_ROLES = Array.from(new Set([...CONTENT_ROLES, ...TICKETING_READ_ROLES]))

/** Where a ticketing-only user lands (they have no dashboard). */
export const TICKETING_HOME = '/ticketing/events'

export const hasAnyRole = (roles: readonly string[], allowed: readonly string[]): boolean =>
  roles.some((role) => allowed.includes(role))
